import Ticker from 'framer-motion-ticker';
import { produce } from 'immer';
import { Tag, Organic3 } from '@hungryroot/icons';
import { Paragraph } from '@hungryroot/ramen';
import { useGetPromoData } from '@hungryroot/rest-hooks';
import { HomepageIcon, HomepageIconVariant } from '../../HomepageIcon';
import styles from './FooterMarquee.module.css';

const content = [
  {
    icon: <Tag />,
    boldText: '30% off',
    normalText: 'first delivery',
  },
  {
    icon: <HomepageIcon variant={HomepageIconVariant.GiftBox} />,
    boldText: 'Free gift',
    normalText: 'every delivery',
  },
  {
    icon: <HomepageIcon variant={HomepageIconVariant.DeliveryTruck} />,
    boldText: 'Free shipping',
    normalText: 'over $70',
  },
  {
    icon: <HomepageIcon variant={HomepageIconVariant.BestPrice} />,
    boldText: 'Best price',
    normalText: 'groceries',
  },
  {
    icon: <Organic3 />,
    boldText: 'Sustainably',
    normalText: 'sourced',
  },
];

export function FooterMarquee() {
  const { data: promoData } = useGetPromoData();
  let footerContent = content;
  if (promoData !== undefined && promoData.effect_base !== '') {
    footerContent = produce(content, (draft) => {
      draft[0] = {
        ...content[0],
        boldText: promoData.effect_base,
        normalText: '',
      };
    });
  }

  return (
    <div className={styles.container}>
      <Ticker duration={40}>
        {footerContent.map((item) => (
          <div key={item.boldText} className={styles.item}>
            {item.icon}
            <Paragraph>
              <span className={styles.bold}>{item.boldText}</span>{' '}
              {item.normalText !== '' && item.normalText}
            </Paragraph>
          </div>
        ))}
      </Ticker>
    </div>
  );
}
